<template>
  <div>
    <vue-editor :editor-toolbar="toolbar" :value="buffer" @input="input" />
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'

export default {
  name: 'Editor',
  props: ['value'],
  components: {
    'vue-editor': VueEditor
  },
  data: function () {
    return {
      buffer: '',
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ color: [] }, { background: [] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ indent: '-1' }, { indent: '+1' }],
        ['blockquote', 'code-block'],
        ['link'],
        ['clean']
      ]
    }
  },
  methods: {
    input: function (newValue) {
      this.$emit('input', newValue)
    }
  },
  watch: {
    value: function (newValue) {
      this.buffer = newValue
    }
  },
  mounted () {
    this.buffer = this.value
  }
}
</script>

<style>
.ql-toolbar.ql-snow {
  background-color: rgb(253, 253, 253);
}
.ql-editor {
  background-color: #fff;
}
</style>
